module.exports = __webpack_public_path__ + "c41495171d76fad62fa334e36229f3e0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/angry-18.png
// module id = 1427
// module chunks = 0